export default __webpack_public_path__ + "static/media/6.33ea7012.jpg";